import {baseUrl, buildAuthRequest, handleJsonResponse} from "./util/Common";

function findDeviceById(deviceId) {
    return buildAuthRequest()
        .then((req) => {
            return fetch(`${baseUrl}/devices/${deviceId}`, req);
        })
        .then((res) => {
            return handleJsonResponse(res);
        });
}

function updateDeviceById(deviceId,
                          {
                              title = undefined,
                              protocol = undefined,
                              settings = undefined,
                              metadata = undefined
                          }) {
    return buildAuthRequest(
        'PATCH',
        {'Content-Type': 'application/json'},
        JSON.stringify({
            title: title,
            protocol: protocol,
            settings: settings,
            metadata: metadata
        })
    ).then((req) => {
        return fetch(`${baseUrl}/devices/${deviceId}`, req);
    }).then((res) => {
        return handleJsonResponse(res);
    });
}

export {
    findDeviceById,
    updateDeviceById
}